import { useLocation } from "react-router-dom";
import { STRINGS } from "./strings";

// Locale is derived from the URL: /es (or /es/...) is Spanish, everything
// else is English. No state, no context — just read the path.
export function useLocale() {
  const { pathname } = useLocation();
  return pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";
}

// Returns the string bundle for the current locale.
export function useT() {
  return STRINGS[useLocale()];
}

export { STRINGS };
